import React from "react";
import { connect } from "react-redux";
import {
  setAllConsentSwitch,
  setAllObjectConsentSwitch,
  setConfiguration,
  setScreen,
} from "../../../redux/actions";
import "./Buttons.scss";
import {
  sendPostMessage,
  sendPostMessageNoTracking,
} from "../../../scripts/PostMessage";
import { switchScreenButton } from "../../../scripts/lib/handlers";

const Buttons = (props) => {
  const { configuration } = props;
  const {
    consentButtonSettingsScreen,
    consentButtonInformationScreen,
    settingsButton,
    continueNoTrackingButton,
  } = props.currentLanguage.text;

  const modifyConfigurationHandler = (configuration) => {
    switchScreenButton(configuration).catch(console.error);
    props.setAllConsentSwitch(false);
    props.setAllObjectConsentSwitch(false);
  };

  const handleRejectAll = (configuration) => {
    const updatedConfiguration = {
      ...configuration,
      vendorList: Array.isArray(configuration.vendorList)
        ? configuration.vendorList.map((vendor) => ({
            ...vendor,
            consent: false,
          }))
        : [],
    };
    modifyConfigurationHandler(updatedConfiguration);
    sendPostMessageNoTracking();
  };

  const renderConsentButton = () => {
    switch (props.currentScreen) {
      case 3:
      case 2:
        return (
          <div
            onClick={sendPostMessage}
            className={`btn green${
              configuration.domesticPolicy ? " domestic-btn" : ""
            }`}
          >
            {consentButtonSettingsScreen}
          </div>
        );
      default:
        return (
          <div
            onClick={sendPostMessage}
            className={`btn green${
              configuration.domesticPolicy ? " domestic-btn" : ""
            }`}
          >
            {consentButtonInformationScreen}
          </div>
        );
    }
  };

  return (
    <div id="buttons" className={`${configuration?.vendorList ? "" : "row"}`}>
      {configuration?.vendorList ? (
        <React.Fragment>
          {/* {props.currentScreen === 3 ? (
            <div onClick={handleRejectAll} className="btn red">
              {continueNoTrackingButton || "Continua senza accettare"}
            </div>
          ) : null} */}
          {props.currentScreen === 1 && (
            <>
              <div
                onClick={() => modifyConfigurationHandler(configuration)}
                className={`btn amber${
                  configuration.domesticPolicy ? " domestic-btn" : ""
                }`}
              >
                {settingsButton}
              </div>
              <div onClick={handleRejectAll} className="btn red">
                {continueNoTrackingButton || "Continua senza accettare"}
              </div>
            </>
          )}
          {renderConsentButton()}
        </React.Fragment>
      ) : (
        <div className="btn amber">Loading configuration...</div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return { ...state };
};

export default connect(mapStateToProps, {
  setScreen,
  setConfiguration,
  setAllConsentSwitch,
  setAllObjectConsentSwitch,
})(Buttons);
